import React from "react";
import Banner from "../Components/Banner";

const Home = () => {
  return (
    <>
      <Banner />
    </>
  );
};

export default Home;
